// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.headerProtectedWrapper {
  width: 100%;
  background: #fff;
}

.headerProtectedStyle {
  display: flex;
  align-items: center;
  background-color: #fff;
  height: 55px;
  width: 100%;
  position: relative;
  top: 0;
  z-index: 999;

}

.noTabs{
  border: 1px solid #77797b;
}

.lineProtectedClass {
  height: 6px;
  width: 100%;
  position: absolute;
  top: 0px;
}

.textHeaderProtected {
  color: black;
  font-size: 18px;
  font-weight: 700;
}

.textResponsiveProtected {
  color: black;
  font-size: 18px;
  font-weight: 700;
}

.logoClassProtected {
  width: 160px;
  height: 36px;
  margin-left: 50px;
}

.containerLogoProtected {
  display: flex;
  flex-direction: row;
  margin-top: 3px;
}

.ContainerInfosLoginProtected {
  display: flex;
  padding: 3px 15px 0px 79px;
  width: calc(100% - 55px);
  align-items: center;
  justify-content: space-between;
}


.headerProtectedTabs {
  display: flex;
  gap: 24px;
  padding: 0 95px;
  border-bottom: 1px solid #77797b;
  overflow-x: auto;
  background: #fff;
}

.headerProtectedTab {
  border: 0;
  background: transparent;
  padding: 10px 0px;
  font-weight: 400;
  color: black;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  font-family: 'Bosch Sans', sans-serif;
}

.headerProtectedTab.active, 
.headerProtectedTab:hover {
  color: #007bc0;
  border-bottom: 2px solid #007bc0;
}



@media (min-width: 100px) and (max-width: 835px) {
  .textResponsiveProtected {
    margin-left: 0px;
  }

  .textHeaderProtected {
    display: none;
  }
}

@media (min-width: 835px) {
  .textResponsiveProtected {
    display: none;
  }

  .textHeaderProtected {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/headerProtected/headerProtected.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;;AAEd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,gCAAgC;AAClC;;;;AAIA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["\n.headerProtectedWrapper {\n  width: 100%;\n  background: #fff;\n}\n\n.headerProtectedStyle {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  height: 55px;\n  width: 100%;\n  position: relative;\n  top: 0;\n  z-index: 999;\n\n}\n\n.noTabs{\n  border: 1px solid #77797b;\n}\n\n.lineProtectedClass {\n  height: 6px;\n  width: 100%;\n  position: absolute;\n  top: 0px;\n}\n\n.textHeaderProtected {\n  color: black;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.textResponsiveProtected {\n  color: black;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.logoClassProtected {\n  width: 160px;\n  height: 36px;\n  margin-left: 50px;\n}\n\n.containerLogoProtected {\n  display: flex;\n  flex-direction: row;\n  margin-top: 3px;\n}\n\n.ContainerInfosLoginProtected {\n  display: flex;\n  padding: 3px 15px 0px 79px;\n  width: calc(100% - 55px);\n  align-items: center;\n  justify-content: space-between;\n}\n\n\n.headerProtectedTabs {\n  display: flex;\n  gap: 24px;\n  padding: 0 95px;\n  border-bottom: 1px solid #77797b;\n  overflow-x: auto;\n  background: #fff;\n}\n\n.headerProtectedTab {\n  border: 0;\n  background: transparent;\n  padding: 10px 0px;\n  font-weight: 400;\n  color: black;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  font-size: 14px;\n  font-family: 'Bosch Sans', sans-serif;\n}\n\n.headerProtectedTab.active, \n.headerProtectedTab:hover {\n  color: #007bc0;\n  border-bottom: 2px solid #007bc0;\n}\n\n\n\n@media (min-width: 100px) and (max-width: 835px) {\n  .textResponsiveProtected {\n    margin-left: 0px;\n  }\n\n  .textHeaderProtected {\n    display: none;\n  }\n}\n\n@media (min-width: 835px) {\n  .textResponsiveProtected {\n    display: none;\n  }\n\n  .textHeaderProtected {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
